import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Carrentalmumbai() {



    const cardData = {

keyword: "Car Rental Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Car Rental Mumbai services for airport transfers, local travel, corporate transportation, family trips, weddings, sightseeing tours, and outstation journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup and drop, flexible rental packages, and excellent customer support, we ensure a safe, comfortable, and hassle-free travel experience across Mumbai and beyond.",

topPlaces: [
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a beautiful coastal destination in the Konkan region known for pristine beaches, historic forts, mango orchards, and scenic sea views. It is a popular choice for family vacations and weekend road trips from Mumbai."
    },
    {
        title: "Kaas Plateau",
        description:
            "Kaas Plateau, a UNESCO-recognized biodiversity hotspot, is famous for its seasonal bloom of colorful wildflowers. Nature enthusiasts and photographers frequently visit this spectacular destination from Mumbai."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar Jyotirlinga is one of the most revered pilgrimage destinations in Maharashtra, surrounded by dense forests and scenic mountain landscapes. It attracts devotees and nature lovers throughout the year."
    },
    {
        title: "Tarkarli",
        description:
            "Tarkarli is one of Maharashtra’s finest beach destinations, known for crystal-clear waters, scuba diving, snorkeling, and water sports. It is ideal for adventure seekers and beach lovers."
    },
    {
        title: "Panchgani",
        description:
            "Panchgani is a charming hill station famous for its Table Land, strawberry farms, pleasant climate, and stunning valley views. It is a perfect destination for couples and families."
    },
    {
        title: "Malshej Ghat",
        description:
            "Malshej Ghat is renowned for mist-covered mountains, waterfalls, and breathtaking monsoon scenery. It is one of the most popular road trip destinations from Mumbai."
    },
    {
        title: "Ganpatipule",
        description:
            "Ganpatipule is famous for its ancient Ganpati Temple and beautiful beach along the Konkan coastline. It offers a perfect combination of spirituality and leisure travel."
    },
    {
        title: "Bhandardara",
        description:
            "Bhandardara is a peaceful hill retreat known for Arthur Lake, Randha Falls, Wilson Dam, and scenic natural beauty. It is a preferred destination for camping and nature vacations."
    },
    {
        title: "Dapoli",
        description:
            "Dapoli is a coastal paradise known for beaches, dolphin watching, historic temples, and tranquil surroundings. It is one of the most loved weekend getaway destinations from Mumbai."
    },
    {
        title: "Amboli",
        description:
            "Amboli is a picturesque hill station in the Sahyadri range known for lush greenery, waterfalls, misty valleys, and pleasant weather. It is a favorite monsoon and nature travel destination."
    }
],



services: [
{
name: "Car Rental Mumbai",
description: "Mumbai Airport Cab offers Car Rental Mumbai service for customers seeking reliable, comfortable, and affordable transportation for local travel, airport transfers, corporate commuting, family outings, sightseeing tours, wedding events, business meetings, railway station transfers, and outstation journeys. Our extensive fleet includes Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, Tempo Traveller, Mini Bus, and luxury vehicles suitable for every travel requirement. With professional chauffeurs, well-maintained vehicles, transparent pricing, flexible rental plans, doorstep pickup and drop service, and 24x7 customer support, we ensure every journey is smooth, safe, and convenient. Whether you require transportation for a few hours, a full day, a weekend trip, or an extended tour, our car rental solutions are designed to deliver comfort, reliability, and excellent value."
},
{
name: "Mumbai Car Rental Service",
description: "Mumbai Airport Cab provides Mumbai Car Rental Service with a wide range of chauffeur-driven vehicles suitable for business travel, airport transportation, family vacations, local sightseeing, corporate events, wedding functions, and outstation trips. Our vehicles are regularly maintained for cleanliness, safety, and performance while offering comfortable seating, air-conditioned interiors, and ample luggage space. Supported by experienced chauffeurs, transparent pricing, flexible booking options, and dedicated customer assistance, we deliver dependable transportation solutions for travellers across Mumbai and beyond."
},
{
name: "Rent a Car Mumbai",
description: "Rent a Car Mumbai through Mumbai Airport Cab for comfortable and hassle-free transportation tailored to personal, family, tourist, and corporate travel needs. Our diverse fleet allows customers to choose the ideal vehicle for airport transfers, city travel, holiday tours, business meetings, shopping trips, and long-distance journeys. With professional drivers, affordable rental packages, transparent billing, easy booking procedures, and reliable customer support, we ensure a convenient and enjoyable travel experience from start to finish."
},
{
name: "Mumbai Car Hire",
description: "Mumbai Car Hire service by Mumbai Airport Cab offers flexible transportation solutions for local commuting, corporate travel, sightseeing tours, family functions, airport transfers, and outstation journeys. Our well-maintained fleet includes vehicles of various categories to suit individual travellers, families, groups, and business professionals. With experienced chauffeurs, punctual service, transparent rates, and customer-focused support, we provide safe, comfortable, and dependable transportation throughout Mumbai and surrounding destinations."
},
{
name: "Self Drive Car Mumbai",
description: "Mumbai Airport Cab provides Self Drive Car Mumbai options for customers who prefer independent travel and complete flexibility during their journey. Our self-drive vehicles are available for city travel, business visits, weekend getaways, family vacations, and outstation trips. Customers benefit from well-maintained vehicles, flexible rental durations, competitive pricing, easy booking procedures, and convenient pickup arrangements, making every trip comfortable, private, and enjoyable."
},
{
name: "Chauffeur Car Rental Mumbai",
description: "Chauffeur Car Rental Mumbai service combines premium vehicle comfort with professional driver assistance for airport transfers, executive transportation, family travel, wedding events, sightseeing tours, and long-distance journeys. Mumbai Airport Cab provides experienced chauffeurs trained in safe driving, customer service, route planning, and punctual travel management. Our chauffeur-driven rental service ensures passengers enjoy a stress-free, comfortable, and professional transportation experience."
},
{
name: "Affordable Car Rental Mumbai",
description: "Affordable Car Rental Mumbai service is designed for travellers seeking economical transportation without compromising on safety, comfort, or service quality. Mumbai Airport Cab offers budget-friendly rental options for local travel, airport transfers, family outings, corporate transportation, sightseeing trips, and outstation journeys. With transparent pricing, clean vehicles, professional drivers, and reliable customer support, we provide excellent value and dependable travel solutions."
},
{
name: "Luxury Car Rental Mumbai",
description: "Mumbai Airport Cab offers Luxury Car Rental Mumbai service for customers who prefer premium transportation for weddings, corporate events, VIP travel, airport transfers, business meetings, luxury tours, and special occasions. Our luxury fleet features high-end vehicles with premium interiors, advanced comfort features, professional chauffeurs, and exceptional service standards. We ensure every journey reflects sophistication, convenience, and superior travel comfort."
},
{
name: "Mumbai Outstation Car Rental Service",
description: "Book Mumbai Outstation Car Rental Service with Mumbai Airport Cab for comfortable travel to destinations such as Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Lonavala, Aurangabad, Kolhapur, and many more. Our vehicles are suitable for family vacations, pilgrimage tours, corporate travel, and holiday packages. We provide experienced drivers, flexible itineraries, transparent pricing, and reliable transportation support to ensure enjoyable and stress-free long-distance journeys."
},
{
name: "Mumbai Airport Car Rental",
description: "Mumbai Airport Car Rental service provides timely pickup and drop transportation for domestic and international airport terminals. Mumbai Airport Cab offers comfortable vehicles, professional chauffeurs, flight schedule monitoring, luggage assistance, and reliable airport transfer solutions. Whether travelling for business or leisure, passengers enjoy smooth, convenient, and stress-free transportation to and from Mumbai Airport."
},
{
name: "Mumbai Daily Car Hire",
description: "Mumbai Daily Car Hire service is ideal for customers requiring dedicated transportation throughout the day for meetings, sightseeing, shopping, personal errands, family functions, and business activities. Mumbai Airport Cab provides chauffeur-driven vehicles with flexible schedules, professional drivers, comfortable interiors, and transparent pricing. Our daily rental solutions offer convenience, reliability, and complete travel flexibility."
},
{
name: "Mumbai Weekly Car Rental",
description: "Mumbai Airport Cab offers Mumbai Weekly Car Rental service for travellers, corporate clients, families, and tourists requiring transportation for an extended period. Our weekly rental packages provide cost-effective travel solutions with well-maintained vehicles, professional chauffeurs, flexible usage options, and dedicated customer support. We ensure convenient, reliable, and comfortable transportation throughout the rental duration."
},
{
name: "Mumbai Monthly Car Rental",
description: "Mumbai Monthly Car Rental service provides long-term transportation solutions for businesses, corporate executives, families, project teams, and frequent travellers. Mumbai Airport Cab offers customized monthly rental plans featuring reliable vehicles, professional chauffeurs, maintenance support, flexible scheduling, and competitive pricing. Our long-term rental services are designed to provide convenience, efficiency, and dependable transportation every day."
},
{
name: "Mumbai Business Car Rental",
description: "Mumbai Business Car Rental service is tailored for executives, professionals, and corporate clients requiring dependable transportation for meetings, conferences, airport transfers, client visits, and business tours. Mumbai Airport Cab provides premium vehicles, experienced chauffeurs, punctual service, and executive-level travel convenience. We help business travellers maintain productivity, professionalism, and comfort during every journey."
},
{
name: "Mumbai Family Car Rental",
description: "Mumbai Airport Cab provides Mumbai Family Car Rental service for vacations, sightseeing tours, family gatherings, weddings, airport transfers, religious trips, and weekend outings. Our spacious and comfortable vehicles accommodate families of all sizes while offering professional driver support, luggage convenience, air-conditioned travel, and flexible itineraries. We focus on delivering safe, enjoyable, and memorable travel experiences for every family."
},
{
name: "Mumbai Tourist Car Rental",
description: "Mumbai Tourist Car Rental service offers convenient transportation for visitors exploring Mumbai and nearby destinations. Mumbai Airport Cab provides comfortable vehicles, knowledgeable chauffeurs, flexible sightseeing schedules, and customized travel plans covering tourist attractions, beaches, heritage sites, shopping districts, and cultural landmarks. We ensure tourists enjoy comfortable, organized, and memorable travel experiences throughout their visit."
},
{
name: "Mumbai Long Distance Car Hire",
description: "Mumbai Long Distance Car Hire service is designed for extended road trips, interstate journeys, pilgrimage tours, holiday vacations, corporate travel, and family holidays. Mumbai Airport Cab provides reliable vehicles, experienced highway drivers, comfortable seating, luggage capacity, and flexible travel schedules. We ensure passengers enjoy safe, comfortable, and relaxing transportation regardless of travel distance."
},
{
name: "Mumbai Weekend Car Rental",
description: "Mumbai Airport Cab offers Mumbai Weekend Car Rental service for customers planning short vacations, beach trips, hill station tours, family outings, sightseeing excursions, and leisure travel. Our comfortable vehicles, professional chauffeurs, flexible itineraries, and affordable packages help travellers enjoy memorable weekend getaways with complete convenience and travel comfort."
},
{
name: "Mumbai City Ride Car Rental",
description: "Mumbai City Ride Car Rental service provides reliable transportation for daily commuting, shopping trips, office travel, local sightseeing, personal appointments, hotel transfers, railway station pickups, and airport connectivity. Mumbai Airport Cab offers clean vehicles, professional chauffeurs, affordable pricing, and flexible booking options. We ensure safe, efficient, and comfortable city travel for residents, tourists, and business travellers alike."
}
],

tableData: [
["Car Rental Mumbai","Mumbai Car Rental Service"],
["Rent a Car Mumbai","Mumbai Car Hire"],
["Self Drive Car Mumbai","Chauffeur Car Rental Mumbai"],
["Affordable Car Rental Mumbai","Luxury Car Rental Mumbai"],
["Mumbai Outstation Car Rental Service","Mumbai Airport Car Rental"],
["Mumbai Daily Car Hire","Mumbai Weekly Car Rental"],
["Mumbai Monthly Car Rental","Mumbai Business Car Rental"],
["Mumbai Family Car Rental","Mumbai Tourist Car Rental"],
["Mumbai Long Distance Car Hire","Mumbai Weekend Car Rental"],
["Mumbai City Ride Car Rental","Mumbai Travel Car Rental"]
],


whychoose: [
    {
        WhyChooseheading: "Reliable Car Rental Mumbai Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Car Rental Services in Mumbai for airport transfers, local travel, corporate transportation, sightseeing tours, weddings, and outstation journeys."
    },
    {
        WhyChooseheading: "Wide Range of Rental Vehicles",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to their travel requirements."
    },
    {
        WhyChooseheading: "Perfect for Business and Personal Travel",
        WhyChoosedescription: "Whether you require transportation for meetings, airport transfers, family vacations, special events, or city travel, our rental services offer maximum convenience."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Trips",
        WhyChoosedescription: "Our rental vehicles are available for Mumbai city travel as well as destinations like Pune, Nashik, Shirdi, Mahabaleshwar, Goa, Ahmedabad, Jaipur, and many other locations."
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Specialists",
        WhyChoosedescription: "We provide seamless airport transportation with timely pickups and comfortable vehicles for domestic and international travelers."
    },
    {
        WhyChooseheading: "Professional Chauffeur-Driven Cars",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, punctual service, route expertise, and a smooth travel experience throughout the journey."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Options",
        WhyChoosedescription: "Customers can choose one-way transfers, round trips, multi-day rentals, corporate travel plans, and customized tour packages."
    },
    {
        WhyChooseheading: "Suitable for Families, Tourists, and Corporate Clients",
        WhyChoosedescription: "From solo travelers and families to business executives and large groups, we provide suitable rental vehicles for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "What services are included in Car Rental Mumbai?",
        answer: "Car Rental Mumbai includes airport transfers, local travel, outstation journeys, corporate transportation, sightseeing tours, wedding travel, and customized travel solutions."
    },
    {
        question: "Which vehicles are available for rental?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
    },
    {
        question: "Can I rent a car for Mumbai Airport transfers?",
        answer: "Yes, airport pickup and drop services are available for domestic and international travelers arriving at Mumbai Airport."
    },
    {
        question: "Are rental cars available for outstation travel?",
        answer: "Yes, customers can hire vehicles for Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Lonavala, Ahmedabad, Indore, Bangalore, and many other destinations."
    },
    {
        question: "Can corporate clients book rental vehicles regularly?",
        answer: "Yes, Mumbai Airport Cabs provides daily, monthly, and long-term transportation solutions for businesses and corporate travelers."
    },
    {
        question: "Do you provide chauffeur-driven rental vehicles?",
        answer: "Yes, all rental vehicles include experienced and professional drivers for safe and comfortable travel."
    },
    {
        question: "Can I book a car for weddings and special events?",
        answer: "Yes, rental vehicles are available for weddings, receptions, family functions, VIP guest transportation, and special occasions."
    },
    {
        question: "Are one-way and round-trip rental options available?",
        answer: "Yes, customers can choose one-way travel, round trips, airport transfers, and customized travel packages."
    },
    {
        question: "Is advance booking recommended for car rentals?",
        answer: "Yes, advance booking is recommended to ensure vehicle availability, especially during weekends, holidays, and peak travel seasons."
    },
    {
        question: "How can I book Car Rental Mumbai services?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Kunal Bhatia",
        feedback:
            "The car rental experience was smooth from start to finish. The vehicle was clean, comfortable, and perfectly suited for our business travel requirements.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sonali Desai",
        feedback:
            "Mumbai Airport Cabs arranged an excellent rental vehicle for our family vacation. The chauffeur was professional, the car was well-maintained, and the journey was extremely comfortable.",
        rating: 5
    }
];








































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Car Rental Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/car-rental-mumbai.jpg",
"description": "Book car rental service in Mumbai for local travel, airport transfers, business trips, family outings, and outstation journeys. Mumbai Airport Cabs offers self-drive and chauffeur-driven cars with flexible daily, weekly, and monthly rental options at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/car-rental-mumbai"
}
};







    return (
        <div>

<Helmet>
  <title>Car Rental Mumbai | Rent a Car Service | +91 9545731161</title>

<meta
 name="description"
 content="Book car rental in Mumbai for self-drive or chauffeur-driven cars. Affordable, luxury, and business car rental options available for local, airport, and outstation travel."
/>

<meta
 name="keywords"
 content="car rental mumbai, mumbai car rental service, rent a car mumbai, mumbai car hire, self drive car mumbai, chauffeur car rental mumbai, affordable car rental mumbai, luxury car rental mumbai, mumbai outstation car rental service, mumbai airport car rental, mumbai daily car hire, mumbai weekly car rental, mumbai monthly car rental, mumbai business car rental, mumbai family car rental, mumbai tourist car rental, mumbai long distance car hire, mumbai weekend car rental"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/118.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Carrentalmumbai;